import { render, staticRenderFns } from "./RevenueDetailWidget.vue?vue&type=template&id=77d90b21"
import script from "./RevenueDetailWidget.vue?vue&type=script&lang=js"
export * from "./RevenueDetailWidget.vue?vue&type=script&lang=js"
import style0 from "./RevenueDetailWidget.vue?vue&type=style&index=0&id=77d90b21&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports